/*
 * @Author: caiqin.xie
 * @since: 2023-07-14 10:30:10
 * @lastTime: 2023-11-07 09:58:08
 * @LastEditors: caiqin.xie
 * @message: 使用指南
 * @url: www.picoxr.com/cn/support/usage-guide
 */
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import VideoGuidance from "./components/VideoGuidance";
import DownloadFile from "./components/DownloadFile";
import styles from "./index.module.scss";
import { DOMAIN_API, COUNTRY_HREFLANG, COUNTRY_LIST } from '@/common/const'

const SearchResult = (props: any) => {
  const {ctry, words} = props.data
  // 生成hreflang
  const renderHrefLang = () => {
    return (
      COUNTRY_LIST.map(item => (
        <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/support/usage-guide`} />
      ))
    )
  }
  return (
    <div>
      <Helmet>
        <title>{words.support_usage_guide_seo_title}</title>
        <meta name="description" content={words.support_usage_guide_seo_description} />
        <meta name="keywords" content={words.support_usage_guide_seo_keywords} />
        <link rel="canonical" href={`${DOMAIN_API}/${ctry}/support/usage-guide`} />
        {renderHrefLang()}
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['guide-wrap']}>
        <div className={styles['guide-content']}>
          <h1 className={styles['guide-title']}>
            {words?.support_usage_guide_title}
            {/* Use guide */}
          </h1>
          {/* 视频 */}
          <VideoGuidance ctry={ctry} words={words} />
          {/* 文档 */}
          <DownloadFile ctry={ctry} words={words} />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default SearchResult;
